import Vue from 'vue';
import VueRouter from 'vue-router';

// polyfills
import 'es6-promise/auto';
import 'es5-shim';
import 'es5-shim/es5-sham';
import 'babel-polyfill';

import store from './store';
import routes from './routes';
import App from './components/App.vue';
import Modal from './components/Modal.vue';
import PriceSummary from './components/PriceSummary.vue';
import PriceSummaryOverview from './components/PriceSummaryOverview.vue';
import Edit from './components/Edit.vue';
import InfoBox from './components/InfoBox.vue';
import OrderQuote from './components/Forms/OrderQuote.vue';
import Loading from './components/Loading.vue';

const mount = document.getElementById('order-app');

if (mount) {
    // create router
    const router = new VueRouter({
        base: location.pathname,
        routes,
    });
    const { mode } = window.ORDER_APP_SETTINGS;

    Vue.use(VueRouter);

    // render app
    new Vue({
        el: mount,
        store,
        router,
        render() {
            return <App mode={mode} />;
        },
    });

    // Modals in <body>
    new Vue({
        el: document.getElementById('order-summary-modal'),
        store,
        render() {
            return this.$store.state.priceSummaryModalVisible ? (
                <Modal close="togglePriceSummaryModalVisible">
                    <PriceSummary slot="content" />
                </Modal>
            ) : null;
        },
    });

    new Vue({
        el: document.getElementById('order-summary-overview-modal'),
        store,
        render() {
            return this.$store.state.priceSummaryOverviewModalVisible ? (
                <Modal close="togglePriceSummaryOverviewModalVisible">
                    <PriceSummaryOverview slot="content" />
                </Modal>
            ) : null;
        },
    });

    new Vue({
        el: document.getElementById('order-edit-modal'),
        store,
        render() {
            const { editModalVisible } = this.$store.state;
            return editModalVisible ? (
                <Modal close="toggleEditModalVisible">
                    <Edit slot="content" />
                </Modal>
            ) : null;
        },
    });

    new Vue({
        el: document.getElementById('order-infobox-modal'),
        store,
        render() {
            return this.$store.state.infoBoxModalVisible ? (
                <Modal infobox close="toggleInfoModalVisible">
                    <InfoBox slot="content" />
                </Modal>
            ) : null;
        },
    });

    new Vue({
        el: document.getElementById('order-quote-modal'),
        store,
        render() {
            return this.$store.state.quoteModalVisible ? (
                <Modal form close="toggleQuoteModalVisible">
                    <OrderQuote slot="content" />
                </Modal>
            ) : null;
        },
    });

    // loading overlay
    new Vue({
        el: document.getElementById('order-loading-modal'),
        store,
        render() {
            return this.$store.state.loadingModalVisible ? <Loading text={this.$store.state.loadingModalMessage} /> : null;
        },
    });
}



// WEBPACK FOOTER //
// ./static/js/Order/index.js